import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "overflow-auto px-8px pt-8px pb-8px" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "search flex items-center gap-4px"
}
const _hoisted_4 = {
  key: 1,
  class: "imageList"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "pageList" }
const _hoisted_7 = { class: "List" }
const _hoisted_8 = { key: 3 }

import { onMounted, ref } from 'vue'
import { ArrowDown, Search, ArrowLeft } from '@element-plus/icons-vue'
import { getCategories, recommendations, getmaterials } from '@/api/affairs'
import { ElIcon, ElInput, ElButton, ElPagination, ElEmpty } from 'element-plus'
// @ts-ignore
import elementItem from './elmentItem.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'elementlist',
  props: {
    categoriesElementList: {},
    list: {},
    searchShow: { type: Boolean },
    categoriesShow: { type: Boolean }
  },
  emits: ["back"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const searchValue = ref('')
const selectedCategory = ref('all') // 默认选中"全部"
const title = ref('')
let page = ref({
    pageNum: 1,
    pageSize: 30,
    type: 1,
})
const listItems = ref([]);
const pagetotle = ref(0);
const resetPagination = () => {
    page.value.pageNum = 1;
    pagetotle.value = 0;
    listItems.value = [];
}
let category_Id = ref('')
let keywords = '';
onMounted(() => {
    if (!props.categoriesShow) {
        listItems.value = props.list.materials.list
        title.value = props.list.name
        return
    }
    category_Id.value = props.categoriesElementList.id.toString();
    title.value = props.categoriesElementList.name
    getmaterialsList(props.categoriesElementList.id, true, '')
})
const getmaterialsList = (categoryId: string | number, resetData: boolean = false, searchKeywords: string = '') => {
    if (resetData) {
        page.value.pageNum = 1;

    }

    category_Id.value = categoryId.toString();
    let params = Object.assign({}, page.value, {
        "categoryId": category_Id,
        "keywords": searchKeywords,
        hotType: 3,
    })
    getmaterials(params).then(res => {
        pagetotle.value = res.data.data.total;
        listItems.value = res.data.data.list;
    }).catch(error => {
        console.error('加载数据失败:', error);
    });
}

const pagechage = (val: number) => {
    page.value.pageNum = val;
    page.value = Object.assign({}, page.value)
    console.log(page.value)
    getmaterialsList(category_Id.value, false, keywords);
}



const emit = __emit

const handleSearch = () => {
    keywords = searchValue.value.trim();
    resetPagination(); // 重置分页
    getmaterialsList(category_Id.value, true, keywords);
}
const handleBack = () => {
    emit('back')
}
const handleCategorySelect = (categoryId: string | number) => {
    selectedCategory.value = categoryId.toString()
    resetPagination(); // 重置分页
    if (categoryId === 'all') {
        getmaterialsList(props.categoriesElementList.id, true, '')
    } else {
        getmaterialsList(categoryId, true, '')
    }
    // selectedCategory.value = categoryId
    // emit('categorySelect', categoryId)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header flex items-center gap-8px mb-12px cursor-pointer",
      onClick: handleBack
    }, [
      _createVNode(_unref(ElIcon), { class: "back-icon cursor-pointer" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowLeft))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, _toDisplayString(title.value), 1)
    ]),
    (__props.searchShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(ElInput), {
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
            placeholder: "请输入搜索内容",
            clearable: "",
            "prefix-icon": _unref(Search)
          }, null, 8, ["modelValue", "prefix-icon"]),
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: handleSearch,
            style: {"background-color":"#2a66ff"}
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("搜索", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (__props.categoriesShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["menu-items", { active: selectedCategory.value === 'all' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleCategorySelect('all')))
          }, " 全部 ", 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categoriesElementList.children, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["menu-items", { active: selectedCategory.value === item.id }]),
              onClick: ($event: any) => (handleCategorySelect(item.id))
            }, _toDisplayString(item.name), 11, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItems.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "image-item"
          }, [
            _createVNode(elementItem, { template: item }, null, 8, ["template"])
          ]))
        }), 128))
      ])
    ]),
    (pagetotle.value > _unref(page).pageSize)
      ? (_openBlock(), _createBlock(_unref(ElPagination), {
          key: 2,
          style: {"margin-top":"20px","width":"100%"},
          background: "",
          layout: "prev, pager, next",
          small: "",
          "pager-count": "5",
          total: pagetotle.value,
          "page-size": _unref(page).pageSize,
          onChange: pagechage,
          ref: "pagination"
        }, null, 8, ["total", "page-size"]))
      : _createCommentVNode("", true),
    (listItems.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_unref(ElEmpty), { description: "暂无数据" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})